import React, { useState } from "react";

function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false);

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setEmailError("");

    // ✅ Validation
    if (!email || !password) {
      setError("Please enter email and password");
      return;
    }

    const username = email;

    if (!isValidEmail(email)) {
      setEmailError("Enter a valid email address");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("/v1/clinic/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ username, password }) // ✅ send email
      });

      if (!res.ok) {
        setError("Invalid email or password");
        return;
      }

      const data = await res.json();

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data));

      onLogin();
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-glow login-glow-a" />
      <div className="login-glow login-glow-b" />

      <div className="login-card">
        <div className="login-badge">VetOps</div>
        <h3 className="login-title">Clinic access</h3>
        <p className="login-copy">
          Sign in to manage appointments, prescriptions, stock, and billing in one place.
        </p>

        <form onSubmit={handleSubmit}>
          {/* ✅ Email Field */}
          <div className="mb-3">
            <input
              type="email"
              className={`form-control login-input ${emailError ? "is-invalid" : ""}`}
              placeholder="Email address"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError("");
              }}
            />
            {emailError && (
              <div className="invalid-feedback">
                {emailError}
              </div>
            )}
          </div>

          {/* ✅ Password Field */}
          <div className="mb-3">
            <input
              type="password"
              className="form-control login-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {/* ✅ General Error */}
          {error && (
            <div className="alert alert-danger py-2 text-center login-alert">
              {error}
            </div>
          )}
          <button
            className="btn btn-primary w-100 login-button"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Logging in...
              </>
            ) : (
              "Login"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
